var exports = {
  "kL": "DMFriendsView.module__container___QTduMT",
  "Em": "DMFriendsView.module__mainColumn___QTduMT",
  "Qs": "DMFriendsView.module__content___QTduMT",
  "sf": "DMFriendsView.module__searchWrapper___QTduMT",
  "qc": "DMFriendsView.module__searchIcon___QTduMT",
  "MJ": "DMFriendsView.module__tabBody___QTduMT",
  "VW": "DMFriendsView.module__headerContent___QTduMT",
  "cP": "DMFriendsView.module__titleSection___QTduMT",
  "gr": "DMFriendsView.module__titleIcon___QTduMT",
  "Qw": "DMFriendsView.module__titleText___QTduMT",
  "yF": "DMFriendsView.module__divider___QTduMT",
  "me": "DMFriendsView.module__tabsWrapper___QTduMT",
  "xd": "DMFriendsView.module__tabsScroller___QTduMT",
  "VD": "DMFriendsView.module__tabsInner___QTduMT",
  "eg": "DMFriendsView.module__tabButton___QTduMT",
  "vu": "DMFriendsView.module__active___QTduMT",
  "zB": "DMFriendsView.module__primary___QTduMT",
  "Lj": "DMFriendsView.module__tabContent___QTduMT",
};

module.exports = exports;
